<template>
  <div class="student-fields" style="width:100%;">
    <h2>{{ $t("user.roles.student.title") }}</h2>
    <v-flex xs12>
      <v-text-field
        v-model="data.relation.notice"
        :disabled="!canEdit"
        :rules="$rules('app.text.small')"
        :label="$t('user.roles.student.notice')"
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model="data.relation.age"
        :disabled="!canEdit"
        :rules="$rules('user.age')"
        :label="$t('user.roles.student.age')"
      />
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    submitting: Boolean,
    canEdit: Boolean
  },
  data() {
    return {
      initStudent: null,
      student: null
    };
  },
  computed: {
    // TODO: Use an adapter by using vuex to prevent duplicated code
    mergedUser: function() {
      // Create a copy of the user to avoid altering it
      var adaptedUser = JSON.parse(JSON.stringify(this.data));
      if (adaptedUser.relation) {
        adaptedUser.student = adaptedUser.relation;
        delete adaptedUser.relation;
      }
      return adaptedUser;
    }
  },
  watch: {
    student: {
      handler() {
        this.updateParent();
      },
      deep: true
    },
    submitting: {
      handler(val) {
        if (val) {
          this.submit();
        }
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      // Igone null values
      this.data.relation.notice = this.data.relation.notice
        ? this.data.relation.notice
        : "";
      this.data.relation.age = this.data.relation.age
        ? this.data.relation.age
        : "";

      this.student = this.data.relation;
      this.updateInitStudent();
    });
  },
  methods: {
    /**
     * Tells the parent if fields data have changed.
     */
    updateParent() {
      const changed = !(
        this.student.notice == this.initStudent.notice &&
        this.student.age == this.initStudent.age
      );
      this.$emit("dataChanged", changed);
    },

    /**
     * Updates the reference student object to compare for changes.
     */
    updateInitStudent() {
      const student = this.data.relation;
      this.initStudent = {
        notice: student.notice,
        age: student.age
      };
    },

    /**
     * Submit the form to the backend.
     */
    submit() {
      this.$store
        .dispatch("user/update", this.mergedUser)
        .then(response => this.successUpdate(response))
        .catch(error => this.errorUpdate(error));
    },

    /**
     * If the submission has been successful.
     */
    // eslint-disable-next-line no-unused-vars
    successUpdate(response) {
      this.updateInitStudent();
      this.$emit("submitted", {
        type: "success",
        message: this.$t("app.actions.success.update")
      });
    },

    /**
     * If an error occurred while submitting the form.
     */
    errorUpdate(error) {
      if (process.env.NODE_ENV !== "production") {
        console.log(error);
      }
      this.$emit("submitted", {
        type: "error",
        message: this.$t("app.actions.failed.update")
      });
    }
  }
};
</script>
